import {
  createTheme,
  responsiveFontSizes,
  experimental_sx as sx,
} from "@mui/material";

const globalTheme = createTheme({
  typography: {
    fontFamily: [
      "Montserrat",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    formTitle: {
      fontSize: "34px",
      fontWeight: "bold",
      color: "#373737",
    },
    title: {
      fontSize: "24px",
      fontWeight: "bold",
      color: "#373737",
    },
    h2: {
      fontSize: 54,
    },
    poppins: {
      fontFamily: "Poppins",
    },
    hn: {
      fontFamily: '"Helvetica Neue"',
    },
  },
  palette: {
    primary: {
      main: "#108757",
    },
    secondary: {
      main: "#979797",
    },
    yellow: "#FFBE00",
    green: "#108757",
    maire: "#00261A",
    muted: {
      main: "#EDEDED",
      dark: "#373737",
    },
    action: {
      selected: "#E7A615",
      hover: "rgba(16, 135, 87, 0.08)",
      disabled: "#9B9B9B",
    },
  },
  // Components
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.size === "large" && {
            padding: "15px 57px",
            lineHeight: "30px",
            fontSize: "18px",
          }),
          ...(ownerState.size === "medium" && {
            padding: "10px 54px",
            lineHeight: "30px",
            fontSize: "16px",
          }),
        }),
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: ({ ownerState }) => {
          return {
            ...((ownerState.type === "password" ||
              (ownerState.type === "text" && ownerState.size !== "small")) && {
              height: "60px",
            }),
            fieldset: {
              borderWidth: "2px",
            },
            ["input, .MuiSelect-select"]: {
              height: "1.6875em",
            },
            ["[type=password]"]: {
              fontSize: "52px",
              lineHeight: "18px",
              caretColor: "transparent",
            },
          };
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: ({ ownerState }) => {
          return {
            // ...(ownerState.size !== "small" && {
            //   height: "60px",
            //   "& .Mui-selected": {
            //     color: "red",
            //   },
            // }),
          };
        },
      },
    },
  },
});

export default responsiveFontSizes(globalTheme);
